const blogFilters = () => {
    const blogFiltersSections = document.querySelectorAll('[data-blog-filters]');
    blogFiltersSections.forEach((section) => {
        const blogFilters = section.querySelectorAll('.blog-filters__filter');
        const indicator = section.querySelector('[data-blog-filters-indicator]');
        blogFilters.forEach((filter) => {
            filter.addEventListener('mouseover', () => {
                const width = filter.offsetWidth;
                const left = filter.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
            filter.addEventListener('mouseout', () => {
                const activeFilter = section.querySelector('.blog-filters__filter--active');
                const width = activeFilter.offsetWidth;
                const left = activeFilter.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
            filter.addEventListener('click', () => {
                // remove active class from all filters
                blogFilters.forEach((f) => {
                    f.classList.remove('blog-filters__filter--active');
                });
                // update active filter
                filter.classList.add('blog-filters__filter--active');
                // update indicator position
                const width = filter.offsetWidth;
                const left = filter.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
                const offsetLeft = filter.offsetLeft;
                const tabWidth = filter.offsetWidth;
                const containerWidth = filter.parentElement.offsetWidth;
                let extraSpace = containerWidth - tabWidth;
                extraSpace = extraSpace / 2;
                filter.parentElement.scrollLeft = offsetLeft - extraSpace;
                // Fetch Posts
                const pageUrl = filter.getAttribute('data-blog-filter-url');
                const sectionHandle = 'article-grid';
                const fetchUrl = `${pageUrl}?section_handle=${sectionHandle}`;
                // targetElement needs to be updated after blogArchiveSection is completed
                // assuming container is a div with id 'article-grid__articles'
                const targetElement = document.querySelector('.article-grid');
                fetch(fetchUrl)
                    .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.text(); // Extract the HTML content
                })
                    .then((htmlContent) => {
                    const parser = new DOMParser();
                    const parsedHtml = parser.parseFromString(htmlContent, 'text/html');
                    // Example: Find the blog archive section in the fetched content
                    const blogArchiveSection = parsedHtml.querySelector('.article-grid');
                    // Example: Append the section content to the targetElement
                    if (blogArchiveSection) {
                        targetElement.innerHTML = blogArchiveSection.innerHTML;
                    }
                    else {
                        console.error('Blog archive section not found in the fetched content.');
                    }
                })
                    .catch((error) => {
                    console.error('There was a problem with your fetch operation:', error);
                });
            });
        });
        window.addEventListener('load', () => {
            const activeFilter = section.querySelector('.blog-filters__filter--active');
            const width = activeFilter.offsetWidth;
            const left = activeFilter.offsetLeft;
            indicator.style.setProperty('--left', left + 'px');
            indicator.style.setProperty('--width', width + 'px');
        });
    });
};
export { blogFilters };
